import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=f3935964&scoped=true"
import script from "./HeatMap.vue?vue&type=script&lang=js"
export * from "./HeatMap.vue?vue&type=script&lang=js"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=f3935964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3935964",
  null
  
)

export default component.exports